import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Star = (props: IIconProps & { isOutline?: boolean }) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M11.2943 4.43828C11.5989 3.85391 12.4011 3.85391 12.7058 4.43828L14.6972 8.25809C14.8129 8.47986 15.0177 8.63551 15.255 8.68201L19.3433 9.48287C19.9688 9.60539 20.2167 10.4034 19.7795 10.8871L16.922 14.0487C16.7561 14.2323 16.6779 14.4841 16.709 14.7346L17.2442 19.0494C17.3261 19.7095 16.6771 20.2027 16.1023 19.9173L12.3447 18.0515C12.1266 17.9431 11.8734 17.9431 11.6553 18.0515L7.89774 19.9173C7.32289 20.2027 6.67393 19.7095 6.75581 19.0494L7.29104 14.7346C7.32212 14.4841 7.24389 14.2323 7.07799 14.0487L4.22048 10.8871C3.78332 10.4034 4.0312 9.60539 4.65665 9.48287L8.74498 8.68201C8.98234 8.63551 9.18714 8.47986 9.30276 8.25809L11.2943 4.43828Z"
      fill={props.isOutline ? "transparent" : "currentColor"}
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </Icon>
);

export default Star;
